import { render, staticRenderFns } from "./EditAnswer.vue?vue&type=template&id=2c0b79de&scoped=true"
import script from "./EditAnswer.vue?vue&type=script&lang=js"
export * from "./EditAnswer.vue?vue&type=script&lang=js"
import style0 from "./EditAnswer.vue?vue&type=style&index=0&id=2c0b79de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0b79de",
  null
  
)

export default component.exports